import type { CountryUtil, UserTypes } from '@fibl/oxs-common';
import { EAV, SearchRepo } from '@fibl/zdb-common';
import { defineStore } from 'pinia';

export const useUserListStore = defineStore('userlist', {
	state: () => ({
		countriesToAutViewers: {} as Record<CountryUtil.CountryCode, string[]>,
	}),

	getters: {
		getAutViewersForCountry: (state) => (cc: CountryUtil.CountryCode) => {
			if (state.countriesToAutViewers[cc].length) return state.countriesToAutViewers[cc];
			return [];
		},
	},

	actions: {
		async loadAutViewersPerCountry(countries: CountryUtil.CountryCode[]) {
			for (let cc of countries) {
				if (!this.countriesToAutViewers[cc]) {
					const countryAut = await SearchRepo.searchOnlyIds('account', {
						$and: [
							{
								field: '/data/registrationOptionName',
								comparison: 'eq',
								value: 'aut',
							},
							{
								field: '/data/staticData/country',
								comparison: 'eq',
								value: cc,
							},
						],
					}, { limit: 200 });
					this.countriesToAutViewers[cc] = countryAut;
				}
			}
		},
	},
});
